import { createApi } from '@reduxjs/toolkit/query/react';

import { RATE_SETTER_API_URL } from 'api/APIBase';
import { handleError } from 'services/Error';
import { getBaseQuery } from 'store/api/apiBaseQuery';

export const rateSetterApi = createApi({
    baseQuery: getBaseQuery(RATE_SETTER_API_URL),
    reducerPath: 'rateSetterApi',
    endpoints: (build) => ({
        postDetermineReferralRates: build.query({
            query: ({
                payerId,
                segmentId,
                productServiceOid,
                benefit,
                isBrand,
                memberId,
                memberFirstName,
                memberDateOfBirth,
                routeCode,
                placeOfService,
                lineOfBusiness,
                supplierNpi,
                routingOfferRate,
                routingUseDeepestRate,
            }) => ({
                url: '/admin/rate_rules/determine_referral_rates',
                method: 'POST',
                body: {
                    payer_id: payerId,
                    segment_id: segmentId,
                    product_service_oid: productServiceOid,
                    benefit,
                    place_of_service: placeOfService,
                    member: {
                        member_id: memberId,
                        member_first_name: memberFirstName,
                        member_date_of_birth: memberDateOfBirth,
                    },
                    route_code: routeCode,
                    is_brand: isBrand,
                    line_of_business: lineOfBusiness,
                    supplier_npi: supplierNpi,
                    routing_offer_rate: routingOfferRate,
                    routing_use_deepest_rate: routingUseDeepestRate,
                },
            }),
            transformResponse: (response) => ({
                baselineRate: response?.baseline_rate,
                defaultRate: response?.default_rate,
                offerRate: response?.offer_rate,
                referentPriceType: response?.referent_price_type,
                priceSource: response?.price_source,
                isFrozen: response?.is_frozen,
            }),
            transformErrorResponse: (err) => {
                if (err.status !== 404) {
                    handleError('Error determining referral rates', err);
                }
            },
        }),
    }),
});

export const { usePostDetermineReferralRatesQuery, useLazyPostDetermineReferralRatesQuery } =
    rateSetterApi;
